<template>
  <div class="columns is-multiline is-mobile">
    <div class="column">
      <window title="Date/Time Picker - Default">
        <el-date-picker v-model="value1" type="datetime" placeholder="Select date and time">
        </el-date-picker>
        {{value1}}
      </window>
    </div>
    <div class="column">
      <window title="Date/Time Picker - With shortcuts">
        <el-date-picker v-model="value2" type="datetime" placeholder="Select date and time"
          :picker-options="pickerOptions1"
        >
        </el-date-picker>
        {{value2}}
      </window>
    </div>
    <div class="column">
      <window title="Date/Time Picker - With default time">
        <el-date-picker v-model="value3" type="datetime" placeholder="Select date and time"
          default-time="12:00:00"
        >
        </el-date-picker>
        {{value3}}
      </window>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pickerOptions1: {
        shortcuts: [{
          text: 'Today',
          onClick(picker) {
            picker.$emit('pick', new Date());
          },
        }, {
          text: 'Yesterday',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - (3600 * 1000 * 24));
            picker.$emit('pick', date);
          },
        }, {
          text: 'A week ago',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - (3600 * 1000 * 24 * 7));
            picker.$emit('pick', date);
          },
        }],
      },
      value1: '',
      value2: '',
      value3: '',
    };
  },
};
</script>
